import React, {useRef, useState,useEffect} from 'react';
import './RmsSupportAIChatBot.css';
import { Icon } from '../../../globalUtils/globalIcons';
import CustomSearchBox from '../rmsSupportAIChatDashboard/CustomSearchBox';
import { useAppDispatch, useAppSelector } from '../../../globalUtils/globalExports';
import { fetchRmsSupportSearchQueryResponse, getRmsSupportCenterReducer, rmsSupportCenterTypes } from '../../../rmsReduxStore/reduxExports';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomPulseLoader from '../../softwareReleaseManagement/dashboard/CustomPulseLoader';

const RmsSupportAIChatDashboard:React.FC = ()=>{
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const queryObject = location?.state
    const [queryText,setQueryText] = useState('');
    const {rmsSupportSearchQueryResponse,rmsSupportSearchQueryResponseLoader,rmsSupportSearchQuery} = useAppSelector(getRmsSupportCenterReducer);
    const [searchQueryResponses,setSearchQueryResponses] = useState<ISearchQueryResponse[]>([queryObject]);
    const chatSectionRef = useRef<HTMLDivElement>(null);
    const submitBtnRef = useRef<HTMLDivElement>(null);
    const newResponseRef = useRef<HTMLDivElement>(null);
    


    const queryBoxResourcesButtons = [
        {
            id:'rms-ai-chatbot-icon',
            className:'rms__support__ai__chatbot-body-query-box-ai-chatbot-icon-btn',
            iconClassName:'rms__support__ai__chatbot__icon-small',
            onClick:()=>{
                const action = {
                    type: rmsSupportCenterTypes.CLEAR_RMS_SUPPORT_SEARCH_QUERY_RESPONSE,
                }
                dispatch(action)
                navigate('/rms-support-center');
            }
        },
        // {
        //     id:'troubleshoot-icon',
        //     className:'rms__support__ai__chatbot-body-query-box-troubleshoot-btn',
        //     iconClassName:'rms__support__troubleshoot__btn__icon',
        //     onClick:()=>{}
        // },
        // {
        //     id:'documentation-icon',
        //     className:'rms__support__ai__chatbot-body-query-box-documentation-btn',
        //     iconClassName:'rms__support__documentation__btn__icon',
        //     onClick:()=>{}
        // }
    ] 

    const handleSearchQueryChange = (value:string)=>{
        setQueryText(value);    
    }

    const handleSubmitBtnClick = ()=>{
        if(!queryText || queryText.trim() === '')return;
        // remove trailing \n
        const cleanText = queryText.split('\n').filter(line => line.trim()!=='').join('\n')
        const context = rmsSupportSearchQueryResponse?.map(res => ({query:res?.query, response: res?.result?.text}))
        dispatch(fetchRmsSupportSearchQueryResponse({query:cleanText,context}))
        setQueryText('')
    }

    //To simulate submit click when user pressess enter
    const handleEnterKeyDown = (e)=>{
        if(e.key === 'Enter' && !e.shiftKey){
            submitBtnRef?.current?.click();
        }
    }

    const handleArticleLinkClicked = (link:string)=>{
        navigate(link)
    }

    useEffect(()=>{
        if(newResponseRef.current){
            newResponseRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    },[searchQueryResponses])

    useEffect(()=>{
     if(rmsSupportSearchQueryResponseLoader){
        setSearchQueryResponses([...rmsSupportSearchQueryResponse,{id:'rms-support-recent-query',query:rmsSupportSearchQuery,result:null} as ISearchQueryResponse])
     }
     else setSearchQueryResponses([...rmsSupportSearchQueryResponse]);
    },[rmsSupportSearchQueryResponse,rmsSupportSearchQueryResponseLoader])


    function getTabCount(line: string): number {
        const match = line.match(/^ +/);
        return match ? match[0].length : 0;
    }


    const parseResultText = (summary: string): React.ReactElement => {
        /*
         * This function is written to parse the response from backend by 
            1: Mark everything included in ** ** as bold
            2: Any line starting with - is new line
         */

        const lines = summary.split(/\n+/)?.filter(line => line.trim()!=='');
    
        const data = lines.map(line => {
            const isBullet = line.trim().startsWith('-');
            if(isBullet)console.log(line)
            const tabCount = getTabCount(line);
            if(isBullet) line = line.replaceAll('-','');
            const listStyle = tabCount >= 7 ? 'circle'  : tabCount >= 5 ? 'square' :  'disc' ;
            console.log(line,listStyle)
            const parts = line.split(/(\*\*.*?\*\*)/g);
            const items = parts.map((part,i)=>{
                if(part.startsWith('**') && part.endsWith('**')) {
                    return (
                        <strong key={`${part}-${i}`}>
                            {part.slice(2, -2)}
                        </strong>
                    );
                }
                return <span key={i}>{part}</span>;
            })
            return (
                isBullet ? <li style={{
                    marginLeft: tabCount > 0 ? tabCount * 8 : 8,
                    listStyleType: listStyle,
                    listStylePosition: 'inside',
                }}>
                    {items}
                </li>
                :
                <>
                    {items}
                </>
            )
        })

        return (
            <div className='rms__ai__query__formatted__output'>
                {data}
            </div>
        )
    }

    return (
        <div className='rms__support__ai__chatbot__container'>
            {/* <div className='rms__support__ai__chatbot-header'>
                <div className='rms__support__ai__chatbot-heading'>
                    <div className='rms__support__ai__chatbot-heading-icon' onClick={()=>{navigate('/rms-support-center')}}>
                       <Icon
                        containerClassName='rms__support__ai__chatbot-heading-icon-container'
                        iconClassName='rms__support__ai__chatbot__icon'
                       />
                    </div>
                </div>
            </div> */}
            <div className='rms__support__ai__chatbot-body'>
                <div className='rms__support__ai__chatbot-body-top' ref={chatSectionRef}>
                    {
                        searchQueryResponses?.map((res,index)=>{
                            return (
                                <div key={res.id} className={'rms__support__ai-response-container'}
                                    ref={index === searchQueryResponses.length - 1 ? newResponseRef : null}
                                >
                                    <div className={'rms__support__ai-query-container'}>
                                        <div className='rms__support__ai-query'>{res.query}</div>
                                    </div>
                                    {
                                        res?.result ? <div className={'rms__support__ai-query-result-container'}>
                                        <div className='rms__support__ai-query-result-text'>
                                            {parseResultText(res?.result?.text)}
                                        </div>
                                        {
                                          res?.result?.links && res?.result?.links?.length > 0  &&  <div className='rms__support__ai-query-result-help-links-container'>
                                            <div className='rms__support__ai-query-result-help-links-header'>
                                                Helpful Links:
                                            </div>
                                            <div className='rms__support__ai-query-result-help-links-body'>
                                                <ul className='rms__support__ai-query-result-help-links'>
                                                    {
                                                    res?.result?.links.map(link=>{
                                                        return (
                                                        <li key={'link-' + link?.label} className='rms__support__ai-query-result-help-link'>
                                                            <div  onClick={()=>handleArticleLinkClicked(link?.href)}>{link?.label}</div>
                                                             <Icon iconClassName='rms__ai__chat__response__helpful__links__icon' />
                                                        </li>
                                                    )
                                                    })
                                                }
                                                </ul>
                                            </div>
                                            </div>
                                        }
                                    </div> : 
                                    <CustomPulseLoader showLoader={rmsSupportSearchQueryResponseLoader} /> 
                                }
                                </div>
                            )
                        })
                    }
                </div>
                <div className='rms__support__ai__chatbot-body-bottom'>
                    <div className='rms__support__ai__chatbot-body-query-box-container'>
                        <div className='rms__support__ai__chatbot-body-query-box'>
                           <div className='rms__support__ai__chatbot-body-query-box-top'>
                             <div className='rms__support__ai__chatbot-body-query-box-text-section'
                             onKeyDown={handleEnterKeyDown}>
                                <CustomSearchBox 
                                inputFieldId={''} 
                                isRequired={false} 
                                inputValue={queryText}
                                handleInputChange={(e)=>{handleSearchQueryChange(e.target.value)}}
                                isResizeable={false}
                                className={''}
                                maxHeight={300}
                                inputPlaceHolder=''
                                enterToSubmit={true}
                                />
                            </div>
                            <div className='rms__support__ai__chatbot-body-query-box-btn-container'>
                                <div className='rms__support__ai__chatbot-body-query-box-btn-container-left'>
                                    {queryBoxResourcesButtons?.map(btn=>{
                                       return( 
                                       <div key={btn.id} className={btn.className} onClick={btn.onClick}>
                                         <Icon  iconClassName={btn.iconClassName}/>
                                        </div> 
                                       );
                                    })}       
                                </div> 
                                <div className='rms__support__ai__chatbot-body-query-box-btn-container-right'>
                                    {/* <div className='rms__support__ai__chatbot-body-query-box-btn-container-right-voice-input-btn'>
                                        <Icon iconClassName='rms__support__voice__input__icon' />
                                    </div> */}
                                    <div className='rms__support__ai__chatbot-body-query-box-btn-container-right-submit-btn'
                                        ref={submitBtnRef}
                                        onClick={handleSubmitBtnClick}>
                                        <Icon iconClassName='rms__support__query__submit__icon' />
                                    </div>
                                </div>
                            </div>
                           </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RmsSupportAIChatDashboard
